import {api, auth, queryClient, useMutationQuery} from 'base'
import {addAuthorizationHeader} from 'base/api'
import {Session, LoginValues, SetSession} from '.'
import {showSuccessNotification} from 'common/helpers'

export const useLogin = (setSession: SetSession) =>
  useMutationQuery<Session, unknown, LoginValues>(
    'login',
    async (values) => {
      const {data} = await auth.post('/auth/login', {
        ...values,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        scope: '*',
        grant_type: 'password',
      })
      return data.tokens
    },
    {
      onSuccess(data) {
        localStorage.setItem('session', JSON.stringify(data))
        addAuthorizationHeader(data)
        setSession(data)
      },
    }
  )

export const useSignUp = (setSession: SetSession, goToNext?: () => void) =>
  useMutationQuery<Session, unknown, any>(
    'signUp',
    async (values) => {
      const {data} = await api.post('/registration', values)
      return data
    },
    {
      onSuccess(data) {
        localStorage.setItem('session', JSON.stringify(data))
        addAuthorizationHeader(data)
        setSession(data)
        showSuccessNotification((data as any)?.message || 'Account is successfully created')
        goToNext?.()
      },
    }
  )

export const useResetPassword = (navigateToLogin: () => void) =>
  useMutationQuery(
    'resetPassword',
    async (values) => {
      const {data} = await api.post('/password/token', values)
      return data
    },
    {
      onSuccess(data) {
        navigateToLogin()
        showSuccessNotification(data.message)
      },
    }
  )
export const useRestorePassword = (navigateToLogin: () => void) =>
  useMutationQuery(
    'password-restore',
    async (values) => {
      const {data} = await api.post('/password/reset', values)
      return data
    },
    {
      onSuccess(data) {
        navigateToLogin()
        showSuccessNotification(data.message)
      },
    }
  )

export const logout = (noReload?: boolean) => {
  api.get('/user/logout')
  localStorage.clear()
  noReload ? queryClient.clear() : window.location.reload()
}

export const useCheckAMLManual = (token: string) =>
  useMutationQuery<Session, unknown, any>('checkAMLManual', async (values) => {
    const {data} = await api.post(`/amlCheck/data/manual/${token}`, values)
    return data
  })

export const useCheckAMLGreenID = (token: string) =>
  useMutationQuery<Session, unknown, any>('checkAMLGreenID', async (values) => {
    const {data} = await api.post(`/amlCheck/data/greenId/${token}`, values)
    return data
  })
